import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, timelineI18n, patesI18n, pastriesSubsI18n } from './i18n';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('murat_lang') || 'fr';
    }
    return 'fr';
  });

  useEffect(() => {
    localStorage.setItem('murat_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];
  const timeline = timelineI18n[lang];
  const patesLoc = patesI18n[lang];
  const pastriesSubs = pastriesSubsI18n[lang];

  const toggle = () => setLang((l) => (l === 'fr' ? 'en' : 'fr'));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, timeline, patesLoc, pastriesSubs }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used within LanguageProvider');
  return ctx;
};
